import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import s from '../../styles/renewal/Toast.module.css';

/**
 * 화면 하단에 잠깐 떠 있는 알림.
 * 섹션에 걸린 transform(.reveal) 안에서는 position:fixed 기준이 틀어질 수 있어 body 로 붙인다.
 */
export default function Toast({ open, tone = 'success', duration = 4500, onClose, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [open, duration, onClose]);

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div className={s.wrap} role="status" aria-live="polite">
      <div className={`${s.toast} ${tone === 'error' ? s.error : s.success}`}>
        <span className={s.icon} aria-hidden="true">
          {tone === 'error' ? '!' : '✓'}
        </span>
        <span className={s.text}>{children}</span>
        <button type="button" className={s.close} onClick={onClose} aria-label="알림 닫기">
          ×
        </button>
      </div>
    </div>,
    document.body,
  );
}
